<template>
  <div>
    <div class="product-listing row center-xs start-md">
      <div v-for="(product, index) in products"
           :key="product._id"
           class="col-sm-6 flex col-xs-12 col-md-6 col-lg-4 mb20"
      >
        <product-tile :product="product"
                      :key="product.sku"
                      :categoryId="category.entity_id"
                      :idx="index"
                      :slides-per-view="currentBreakpoint"
                      :categoryIndex="categoryIndex"
        />
      </div>
    </div>
    <bounce-loader v-if="products.length <= 0 && availableProducts > 0" />
  </div>
</template>

<script>
  import ProductTile from 'theme/components/theme/blocks/Home/ProductTileGrid'
  import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

  let lastHero = 0
  export default {
    name: 'ProductListing',
    components: {
      ProductTile,
      BounceLoader
    },
    props: {
      products: {
        type: null,
        required: true
      },
      category: {
        type: Object,
        required: true
      },
      availableProducts: {
        type: [Number, String],
        required: false,
        default: 0
      },
      columns: {
        type: Number,
        default: 3
      },
      categoryIndex: {
        type: Number
      }
    },
    computed: {
      currentBreakpoint() {
        return this.columns * 2
      },
    }
  }
</script>
